<template>
  <div
    class="app-content content h-auto px-2 d-flex flex-column"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
    style="min-height: 100%; background: F7F7F8;"
    :style="contentMargin"
  >
    <div
      v-show="notifications.length"
    >
      <b-alert
        v-for="notification in notifications"
        :key="notification.id"
        :show="notification.timeout"
        :variant="notification.type"
        class="m-0 col p-0 mr-2 mb-1"
        :dismissible="notification.isDismissible"
        @dismiss-count-down="(e) => notification.timeout = e"
      >
        <div
          class="alert-body text-sm font-weight-normal"
        >
          {{ notification.message }}
        </div>
      </b-alert>
    </div>
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper h-auto d-flex flex-column flex-grow-1 w-100"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <div class="content-body h-auto d-flex flex-grow-1">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {

  data() {
    return {
      notifications: Array.from(JSON.parse(process.env.VUE_APP_NOTIFICATION)),
    }
  },
  computed: {
    contentMargin() {
      if (this.$store.state.app.windowWidth > 1199) {
        if (this.$store.state.projectModule.isSidebarCollapsed) return 'margin-left: 50px'
        return 'margin-left: 260px'
      }
      return ''
    },
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>
